import { LiveProvider } from "@refinedev/core";
import { liveClient } from "client/live.client";
import { SocketListenPayload } from "types/socket.type";

const logTag = "[liveProvider]";

// see https://github.com/refinedev/refine/blob/main/packages/ably/src/index.ts
export const liveProvider = {
  subscribe: ({ channel, params, types, callback }) => {
    console.log(logTag, "subscribe", { channel, params, types });

    if (channel.startsWith("resources/")) {
      const resource = channel.slice("resources/".length);

      const listener = <TData extends { id: string }>(
        event: string,
        payload: SocketListenPayload<TData>
      ) => {
        // process only current resource, compatible and subscribed event types only
        if (
          event === resource &&
          (payload.type === "created" ||
            payload.type === "updated" ||
            payload.type === "deleted") &&
          (types.includes("*") || types.includes(payload.type))
        ) {
          if (
            payload.type === "created" ||
            !params?.ids ||
            params.ids.map(String).includes(payload.data.id)
          ) {
            console.log(logTag, "listener", { event, payload, paramIds: params?.ids });

            callback({
              channel,
              type: payload.type,
              payload: {
                ids: [payload.data.id]
              },
              date: payload.timestamp ? new Date(payload.timestamp) : new Date()
            });
          }
        }
      };

      liveClient.onAny(listener);

      return listener;
    }
  },
  unsubscribe: (listener?: (...args: unknown[]) => void) => {
    console.log(logTag, "unsubscribe", { listener: listener?.name });

    if (listener) {
      liveClient.offAny(listener);
    }
  }
} satisfies LiveProvider;
